//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Videos',

  props: {
    videos: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      CDN: process.env.CDN,
      target: null,
      activeVideoId: null,
    };
  },

  computed: {
    videoItems() {
      return this.videos.map((video) => ({
        thumb: `${this.CDN}/scene/scene_image_${video.id}.jpg`,
        src: `https://www.youtube.com/embed/${video.youtubeId}`,
      }));
    },
  },
};
